import { ItemExtended } from "types/items";
import { ITEM_NAME } from "./item-names";

// Evolution Stones - Classic stones used to evolve certain Pokemon
export const EVOLUTION_STONES: ItemExtended[] = [
  {
    item_name: ITEM_NAME.FIRE_STONE,
    description:
      "A peculiar stone that can make certain species of Pokémon evolve. The stone has a fiery orange heart.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.WATER_STONE,
    description:
      "A peculiar stone that can make certain species of Pokémon evolve. It is the blue of a pool of clear water.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.THUNDER_STONE,
    description:
      "A peculiar stone that can make certain species of Pokémon evolve. It has a thunderbolt pattern.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.LEAF_STONE,
    description:
      "A peculiar stone that can make certain species of Pokémon evolve. It has an unmistakable leaf pattern.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.ICE_STONE,
    description:
      "A peculiar stone that can make certain species of Pokémon evolve. It has an ice pattern within it.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.MOON_STONE,
    description:
      "A peculiar stone that can make certain species of Pokémon evolve. It is as dark as the night sky.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.SUN_STONE,
    description:
      "A peculiar stone that can make certain species of Pokémon evolve. It burns as red as the evening sun.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.DUSK_STONE,
    description:
      "A peculiar stone that can make certain species of Pokémon evolve. It holds shadows as dark as can be.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.DAWN_STONE,
    description:
      "A peculiar stone that can make certain species of Pokémon evolve. It sparkles like eyes awakening at dawn.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.SHINY_STONE,
    description:
      "A peculiar stone that can make certain species of Pokémon evolve. It shines with a dazzling light.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.LINK_CABLE,
    description:
      "A mysterious cable that makes a Pokémon feel like it's being traded, enabling trade evolutions without trading.",
    shop_price: 5000,
  },
];

// Evolution Items - Items specifically used to trigger Pokemon evolution
export const EVOLUTION_ITEMS: ItemExtended[] = [
  {
    item_name: ITEM_NAME.AUSPICIOUS_ARMOR,
    description:
      "A mysterious armor that can cause Charizard to undergo a form change. Its color and design are both quite elegant.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.DUBIOUS_DISC,
    description:
      "A transparent device overflowing with dubious data. It converts Porygon into Porygon-Z.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.ELECTIRIZER,
    description:
      "A box packed with a tremendous amount of electric energy. It converts Electabuzz into Electivire.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.KINGS_ROCK,
    description:
      "An item to be held by a Pokémon. When the holder evolves, it evolves into a different form.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.MAGMARIZER,
    description:
      "A box packed with a tremendous amount of magma energy. It converts Magmar into Magmortar.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.MALICIOUS_ARMOR,
    description:
      "A mysterious armor that can cause Charizard to undergo a form change. Its eerie red color sends chills down the spine.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.METAL_COAT,
    description:
      "A special metallic film that boosts the power of Steel-type moves. It also enables evolution.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.OVAL_STONE,
    description:
      "A peculiar stone that makes certain species of Pokémon evolve. It has an oval shape.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.PRISM_SCALE,
    description:
      "A mysterious scale that causes a certain Pokémon to evolve. It shines in rainbow colors.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.PROTECTOR,
    description:
      "A protective item that boosts the power of Ground-type moves. It enables Rhydon to evolve into Rhyperior.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.RAZOR_CLAW,
    description:
      "An item to be held by a Pokémon. This sharp claw boosts the holder's critical-hit ratio.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.RAZOR_FANG,
    description:
      "An item to be held by a Pokémon. This sharp fang raises the likelihood of inflicting critical hits.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.REAPER_CLOTH,
    description:
      "A cloth imbued with horrifyingly strong spiritual energy. It allows Dusclops to evolve into Dusknoir.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.SACHET,
    description:
      "A sachet filled with fragrant perfumes that are just slightly too overwhelming. It converts Spritzee into Aromatisse.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.UPGRADE,
    description:
      "A transparent device filled with all sorts of data. It converts Porygon into Porygon2.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.WHIPPED_DREAM,
    description:
      "A soft and sweet treat made of fluffy, whipped cream. It's loved by a certain Pokémon.",
    shop_price: 5000,
  },
];

// Loot Items - All items that can be found, collected, or looted in the game world
export const LOOT_ITEMS: ItemExtended[] = [
  // Gems
  {
    item_name: ITEM_NAME.DRAGON_GEM,
    description:
      "A gem with an essence of the heavens. When held, it strengthens the power of a Dragon-type move only once.",
    shop_price: 200,
  },
  {
    item_name: ITEM_NAME.FAIRY_GEM,
    description:
      "A gem with an essence of the heavens. When held, it strengthens the power of a Fairy-type move only once.",
    shop_price: 200,
  },
  {
    item_name: ITEM_NAME.FLYING_GEM,
    description:
      "A gem with an essence of the heavens. When held, it strengthens the power of a Flying-type move only once.",
    shop_price: 200,
  },

  // Valuables
  {
    item_name: ITEM_NAME.NUGGET,
    description:
      "A nugget of the purest gold that gives off a lustrous gleam in direct light. It can be sold at a high price.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.BIG_NUGGET,
    description:
      "A big nugget of the purest gold that gives off a lustrous gleam in direct light. It can be sold at a high price.",
    shop_price: 15000,
  },
  {
    item_name: ITEM_NAME.PEARL,
    description:
      "A pretty pearl that can be sold at a high price. It can be found in certain shells.",
    shop_price: 1400,
  },
  {
    item_name: ITEM_NAME.BIG_PEARL,
    description:
      "A rather large pearl that can be sold at a high price. It can be found in certain shells.",
    shop_price: 3750,
  },
  {
    item_name: ITEM_NAME.STARDUST,
    description:
      "Lovely, red-colored sand with a loose, silky feel. It can be sold at a high price.",
    shop_price: 1000,
  },
  {
    item_name: ITEM_NAME.STAR_PIECE,
    description:
      "A shard of a pretty gem that sparkles in a red color. It can be sold at a high price.",
    shop_price: 4900,
  },
  {
    item_name: ITEM_NAME.GOLD_LEAF,
    description:
      "A strange, gold-colored leaf. It has a nice sheen and can be sold at a high price.",
    shop_price: 1000,
  },
  {
    item_name: ITEM_NAME.SAPPHIRE,
    description:
      "A precious gem that sparkles with a deep blue. It can be sold at a high price.",
    shop_price: 500,
  },

  // Berries and Herbs
  {
    item_name: ITEM_NAME.BASIL,
    description:
      "A fresh herb that makes a certain Pokémon happy when used. It can be sold at a low price.",
    shop_price: 20,
  },
  {
    item_name: ITEM_NAME.KIWI,
    description:
      "A sweet berry that can be eaten. It can be sold at a low price.",
    shop_price: 20,
  },
  {
    item_name: ITEM_NAME.FANCY_APPLE,
    description:
      "A very appealing apple that can be eaten. It can be sold at a low price.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.SWEET_APPLE,
    description:
      "A very sweet apple that can be eaten. It can be sold at a low price.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.SYRUPY_APPLE,
    description:
      "An apple filled with sweet syrup. It can be sold at a low price.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.TART_APPLE,
    description:
      "A tart apple that can be eaten. It can be sold at a low price.",
    shop_price: 5000,
  },

  // Sweet Items
  {
    item_name: ITEM_NAME.BERRY_SWEET,
    description:
      "A flower-shaped sweet. When a Milcery holds this, it spins around happily.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.CLOVER_SWEET,
    description:
      "A flower-shaped sweet. When a Milcery holds this, it spins around happily.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.FLOWER_SWEET,
    description:
      "A flower-shaped sweet. When a Milcery holds this, it spins around happily.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.LOVE_SWEET,
    description:
      "A flower-shaped sweet. When a Milcery holds this, it spins around happily.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.RIBBON_SWEET,
    description:
      "A flower-shaped sweet. When a Milcery holds this, it spins around happily.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.STAR_SWEET,
    description:
      "A flower-shaped sweet. When a Milcery holds this, it spins around happily.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.STRAWBERRY_SWEET,
    description:
      "A flower-shaped sweet. When a Milcery holds this, it spins around happily.",
    shop_price: 5000,
  },

  // Candies
  {
    item_name: ITEM_NAME.CANDY_RED,
    description:
      "A mysterious candy that can change the nature of a Pokémon when given to it.",
    shop_price: 20,
  },
  {
    item_name: ITEM_NAME.CANDY_BLUE,
    description:
      "A mysterious candy that can change the nature of a Pokémon when given to it.",
    shop_price: 20,
  },
  {
    item_name: ITEM_NAME.CANDY_BROWN,
    description:
      "A mysterious candy that can change the nature of a Pokémon when given to it.",
    shop_price: 20,
  },
  {
    item_name: ITEM_NAME.CANDY_GRAY,
    description:
      "A mysterious candy that can change the nature of a Pokémon when given to it.",
    shop_price: 20,
  },
  {
    item_name: ITEM_NAME.CANDY_GREEN,
    description:
      "A mysterious candy that can change the nature of a Pokémon when given to it.",
    shop_price: 20,
  },
  {
    item_name: ITEM_NAME.CANDY_PINK,
    description:
      "A mysterious candy that can change the nature of a Pokémon when given to it.",
    shop_price: 20,
  },
  {
    item_name: ITEM_NAME.CANDY_PURPLE,
    description:
      "A mysterious candy that can change the nature of a Pokémon when given to it.",
    shop_price: 20,
  },
  {
    item_name: ITEM_NAME.CANDY_YELLOW,
    description:
      "A mysterious candy that can change the nature of a Pokémon when given to it.",
    shop_price: 20,
  },
  {
    item_name: ITEM_NAME.EXP_CANDY_XL,
    description:
      "An item that raises a Pokémon's level. It can be used on any Pokémon and grants a large amount of Exp. Points.",
    shop_price: 5000,
  },

  // Held Items
  {
    item_name: ITEM_NAME.AMULET_COIN,
    description:
      "An item to be held by a Pokémon. It doubles the battle money received if the holding Pokémon takes part in battle.",
    shop_price: 100,
  },
  {
    item_name: ITEM_NAME.BRIGHT_POWDER,
    description:
      "An item to be held by a Pokémon. It casts a glare that lowers the opponent's accuracy.",
    shop_price: 10,
  },
  {
    item_name: ITEM_NAME.DAMP_ROCK,
    description:
      "An item to be held by a Pokémon. It extends the duration of the move Rain Dance used by the holder.",
    shop_price: 100,
  },
  {
    item_name: ITEM_NAME.DRAGON_FANG,
    description:
      "A large, sharp fang. Dragon-type moves become more powerful when it is held.",
    shop_price: 100,
  },
  {
    item_name: ITEM_NAME.DRAGON_SCALE,
    description:
      "A thick and tough scale. Dragon-type Pokémon may be holding it.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.FAIRY_FEATHER,
    description:
      "An item to be held by a Pokémon. It slightly boosts the power of Fairy-type moves.",
    shop_price: 100,
  },
  {
    item_name: ITEM_NAME.GOLD_BOTTLE_CAP,
    description:
      "A beautiful bottle cap that gives off a golden gleam. Some people are happy to receive one.",
    shop_price: 50000,
  },
  {
    item_name: ITEM_NAME.HARD_STONE,
    description:
      "An item to be held by a Pokémon. It is a durable stone that boosts the power of Rock-type moves.",
    shop_price: 100,
  },
  {
    item_name: ITEM_NAME.MAGNET,
    description:
      "An item to be held by a Pokémon. It is a powerful magnet that boosts the power of Electric-type moves.",
    shop_price: 100,
  },
  {
    item_name: ITEM_NAME.MINT_ATTACK,
    description:
      "A mint that changes the Pokémon's nature to one that raises Attack but lowers another stat.",
    shop_price: 20,
  },

  // Fossils and Ores
  {
    item_name: ITEM_NAME.ARMORITE_ORE,
    description:
      "A rare ore that can be used to restore ancient Pokémon. It has a curious shape.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.DYNITE_ORE,
    description:
      "A rare ore that can be used to restore ancient Pokémon. It has a curious shape.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.BLACK_AUGURITE,
    description:
      "A glassy black stone that produces a sharp cutting edge when split. It's loved by a certain Pokémon.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.CHALKY_STONE,
    description:
      "A stone with a mysterious, chalk-like substance on it. It boosts the power of Rock-type moves.",
    shop_price: 100,
  },
  {
    item_name: ITEM_NAME.COMET_SHARD,
    description:
      "A shard which fell to the ground when a comet approached. It can be sold at a high price.",
    shop_price: 25000,
  },
  {
    item_name: ITEM_NAME.CRYSTAL_CLUSTER,
    description:
      "A cluster of beautiful crystals. It can be sold at a high price.",
    shop_price: 3000,
  },
  {
    item_name: ITEM_NAME.DEEP_SEA_SCALE,
    description:
      "An item that raises the Sp. Def stat of Clamperl. It can be found in the sea.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.DEEP_SEA_TOOTH,
    description:
      "An item that raises the Sp. Atk stat of Clamperl. It can be found in the sea.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.METAL_ALLOY,
    description:
      "A peculiar metal that is said to be from another world. It boosts the power of Steel-type moves.",
    shop_price: 5000,
  },

  // Flutes
  {
    item_name: ITEM_NAME.BLACK_FLUTE,
    description:
      "A flute made from black glass. It makes wild Pokémon less likely to appear.",
    shop_price: 400,
  },
  {
    item_name: ITEM_NAME.BLUE_FLUTE,
    description: "A flute made from blue glass. It awakens a sleeping Pokémon.",
    shop_price: 100,
  },

  // Other Items
  {
    item_name: ITEM_NAME.BEACH_GLASS,
    description:
      "A piece of colored glass. It's been lovingly polished, so it shines with a pretty light.",
    shop_price: 20,
  },
  {
    item_name: ITEM_NAME.BIG_MUSHROOM,
    description:
      "A large and rare mushroom. It is very popular among collectors and can be sold at a high price.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.BLUE_PETAL,
    description: "A pretty blue petal. It can be sold at a low price.",
    shop_price: 20,
  },
  {
    item_name: ITEM_NAME.HONEY,
    description:
      "A sweet honey with a lush aroma that attracts wild Pokémon when used in grass, caves, or on special trees.",
    shop_price: 100,
  },
  {
    item_name: ITEM_NAME.PEAT_BLOCK,
    description: "A block of muddy peat. It can be sold at a low price.",
    shop_price: 5000,
  },

  // Quest Items
  {
    item_name: ITEM_NAME.CHIPPED_POT,
    description:
      "A chipped pot. It can be sold at a low price, but some collectors will pay a lot for it.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.CRACKED_POT,
    description:
      "A cracked pot. It can be sold at a low price, but some collectors will pay a lot for it.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.GALARICA_CUFF,
    description:
      "A cuff made from woven straw. It's a traditional Galarian craft. It can be sold at a high price.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.GALARICA_WREATH,
    description:
      "A wreath made from woven straw. It's a traditional Galarian craft. It can be sold at a high price.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.MASTERPIECE_TEACUP,
    description:
      "A beautiful teacup that was handmade by a famous artisan. It can be sold at a high price.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.SCROLL_OF_DARKNESS,
    description:
      "An ancient scroll that's filled with the teachings of a noble ninja. It can be sold at a high price.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.SCROLL_OF_WATERS,
    description:
      "An ancient scroll that's filled with the teachings of a noble ninja. It can be sold at a high price.",
    shop_price: 5000,
  },
  {
    item_name: ITEM_NAME.UNREMARKABLE_TEACUP,
    description:
      "A plain teacup. It can be sold at a low price, but some collectors will pay a lot for it.",
    shop_price: 5000,
  },
];

export const CONSUMABLE_ITEMS: ItemExtended[] = [
  {
    item_name: ITEM_NAME.SMALL_POTION,
    description: "A small potion that restores 20 HP.",
    shop_price: 50,
    sold_on_shop: true,
  },
  {
    item_name: ITEM_NAME.POTION,
    description: "A potion that restores 50 HP.",
    shop_price: 100,
    sold_on_shop: true,
  },
  {
    item_name: ITEM_NAME.REVIVE,
    description: "A revive that restores 50% of the Pokémon's HP.",
    shop_price: 250,
    sold_on_shop: true,
  },
];

// Combined items array for backwards compatibility
export const ITEMS: ItemExtended[] = [
  ...EVOLUTION_STONES,
  ...EVOLUTION_ITEMS,
  ...LOOT_ITEMS,
  ...CONSUMABLE_ITEMS,
];
